import React, { Component } from 'react'
import { connect } from 'react-redux'
import Notifications from 'react-notify-toast'

import { loadProfile, loadAttributes, checkExport } from '../actions'

import Nav from './Nav'
import Validate from './Validate'
import WindowSpinner from './WindowSpinner'
import Uploader from './Uploader'
import { Outlet } from 'react-router'

class AuthorizedLayout extends Component {
  constructor() {
    super()
    this.timer = null
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.props.checkExport()
    }, 60000 * 5)
  }

  componentWillMount() {
    if (this.props.profile.roles === null) {
      this.props.loadProfile()
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  render() {
    const { loading } = this.props.profile
    return (
      <div>
        <Validate />
        <Outlet />
        <Nav location={this.props.location} />
        <Notifications />
        <Uploader />
        {loading && <WindowSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  loadProfile,
  loadAttributes,
  checkExport
})(AuthorizedLayout)
